import React, { Component } from 'react';
import { connect } from 'react-redux';

import { push } from 'connected-react-router';
import PageTemplate from '../../components/PageTemplate/PageTemplate';
import './InputPhoto.scss';

//icon
import selectImageIcon from '../../assets/select_image.png';
import cameraIcon from '../../assets/camera.png';

//text
import assistantText from '../../assets/text/text.json';
import Search from '../../services/Search.service';
import { setCurrentSearchImage } from '../../redux/actions/result.action';
import { pushAndStop } from '../../redux/actions/text.action';

/**
 * Home page component
 */
class InputPhoto extends Component<{ navigateTo: any, setCurrentSearchItem: any }, {}> {
    private takePhotoRef: any;
    private pickPhotoRef: any;

    constructor(props: any) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.takePhotoRef = React.createRef();
        this.handleSubmitPickPhoto = this.handleSubmitPickPhoto.bind(this);
        this.pickPhotoRef = React.createRef();
    }
    handleSubmit(event: any) {
        event.preventDefault();
        this.props.setCurrentSearchItem(this.takePhotoRef.current.files[0])
        this.props.navigateTo('inputphotovalidation')

    }
    handleSubmitPickPhoto(event: any) {
        event.preventDefault();
        this.props.setCurrentSearchItem(this.pickPhotoRef.current.files[0])
        this.props.navigateTo('inputphotovalidation')
    }

    renderBody() {
        return (
            <div className="container">
                <div className="container-content">
                    <div className="button">
                        <input type="file" className="inputoverlay" ref={this.takePhotoRef} onChange={(event) => {
                            this.handleSubmit(event);
                        }} />
                        <img src={cameraIcon} className="image" alt="camera-icon" />
                        <div className="text">
                            Foto machen
                        </div>
                    </div>
                    <div className="button" >
                        <input id="myFileInput" type="file" accept="image/*" className="inputoverlay" ref={this.pickPhotoRef} onChange={(event) => {
                            this.handleSubmitPickPhoto(event);
                        }} />
                        <img src={selectImageIcon} className="image" alt="select-icon" />
                        <div className="text">
                            Foto wählen
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    /**
     * Main render method of component
     */
    render() {
        return (
            <div className="inputphoto">
                <PageTemplate assistantLine1={assistantText.inputPhoto.Assistant.line1} assistantLine2={assistantText.inputPhoto.Assistant.line2} page="fotoMethode" body={this.renderBody()} />
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {

    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        navigateTo(path: string) {
            dispatch(pushAndStop(path));
        },
        setCurrentSearchItem(item: any) {
            dispatch(setCurrentSearchImage(item));
        }
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InputPhoto);